import React from 'react';
import PropTypes from 'prop-types';
import { ComponentClassNames } from '../../../../../helper/componen_class_names';

function LightboxView(props) {
    const viewClassNames = new ComponentClassNames('lightbox-filter-view');

    if (props.viewName) {
        viewClassNames.addClassNames('lightbox-filter-view--' + props.viewName);
    }

    if (props.opened) {
        viewClassNames.addClassNames('lightbox-filter-view--opened');
    }

    return (
        <div className={viewClassNames.getClassName()}>
            {props.children}
        </div>
    );
}

LightboxView.propTypes = {
    viewName: PropTypes.string,
};

LightboxView.defaultProps = {
    viewName: '',
};

export { LightboxView };
